import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../store/store';
import get from 'lodash/get';
import { fetchActiveClient } from '../store/slices/clientSlice';

export const useActiveClient = () => {
  const dispatch = useDispatch();
  const { findAllActive } = useSelector((state: AppState) => state.client);

  useEffect(() => {
    dispatch(fetchActiveClient({ limit: 1000 }));
  }, []);

  return {
    items: get(findAllActive, 'payload.items', []),
    itemsLoading: get(findAllActive, 'loading', false)
  };
};
